// Source snapshots keep their observation dates; live quotes only revise the planning estimate.
export const GOAL_BUDGET_EXAMPLES = {
  "home": {
    "budgetToman": 17200000000,
    "budgetNote": "سناریوی ۸۰ متر دوخوابه در محدودهٔ دریاچه چیتگر؛ برآورد منطقه، نه قیمت یک فایل مشخص.",
    "scenario": {
      "title": "آپارتمان حدود ۸۰ متر، دوخوابه، محدودهٔ دریاچه چیتگر تهران",
      "checkedAt": "2026-10-01",
      "logic": "۸۰ متر × میانگین ۲۱۳٫۹ میلیون تومان برای هر متر از آگهی‌های منطقه = ۱۷٫۱۱۲ میلیارد؛ برای برنامه‌ریزی به ۱۷٫۲ میلیارد گرد شده. دوخوابه‌بودن فرض این سناریوست و شاخص جداگانه‌ای برای آن نداریم.",
      "sources": [
        {
          "label": "آریامرز، شاخص آگهی‌های دریاچه",
          "url": "https://www.ariamarz.com/buy-apartment/tehran-district22-daryacheh-shohadaye-khalij-fars",
          "amount": 213900000,
          "unit": "toman_per_m2",
          "date": "1405-07",
          "indexed": false
        }
      ]
    }
  },
  "vehicle": {
    "budgetToman": 8300000000,
    "budgetNote": "جیمنی پنج‌درب مدل ۲۰۲۵؛ بر اساس شاخص قیمت بازار.",
    "scenario": {
      "title": "سوزوکی جیمنی ۵درب مدل۲۰۲۵",
      "checkedAt": "2026-10-01",
      "logic": "مبنای پایه، قیمت بازارِ مدل ۲۰۲۵ در وان‌کار است؛ شاهد فروشنده سال مدل را تفکیک نکرده و صرفاً برای مقایسه است.",
      "sources": [
        {
          "label": "وان‌کار، جیمنی ۵درب۲۰۲۵",
          "url": "https://1car.ir/price",
          "amount": 8300000000,
          "unit": "toman",
          "date": "1405-07-09",
          "indexed": false
        },
        {
          "label": "پدیده خودرو، عرضه جیمنی۵درب مدل۲۰۲۴/۲۰۲۵",
          "url": "https://padidehkhodro.com/product/سوزوکی-جیمنی/",
          "amount": 7670000000,
          "unit": "toman",
          "date": "1405-07-07 table; relative header 22 minutes ago inconsistent",
          "indexed": false
        }
      ]
    }
  },
  "laptop": {
    "budgetToman": 177000000,
    "budgetNote": "لنوو IdeaPad Slim 3؛ پردازنده i5، رم ۱۶ و حافظهٔ ۵۱۲ گیگابایت.",
    "scenario": {
      "title": "لنوو IdeaPad Slim 3، i5-13420H، رم۱۶ و SSD۵۱۲",
      "checkedAt": "2026-10-01",
      "logic": "مبلغ پایه از قیمت ۱۷۶٫۸ میلیون تومانی نمونه، به ۱۷۷ میلیون گرد شده.",
      "sources": [
        {
          "label": "تکنولایف‌پلاس",
          "url": "https://www.technolife.com/product-133524/لپ-تاپ-لنوو-15.3-اینچی-مدل-ideapad-slim-3-i5-13420h-16gb-512gb",
          "amount": 176800000,
          "unit": "toman",
          "date": null,
          "indexed": false
        }
      ]
    }
  },
  "tablet": {
    "budgetToman": 67000000,
    "budgetNote": "شیائومی Redmi Pad 2 Pro، حافظهٔ ۲۵۶ و رم ۸؛ تبلت میان‌رده بدون لوازم اضافه.",
    "scenario": {
      "title": "شیائومی Redmi Pad 2 Pro، ۱۲٫۱اینچ، ۲۵۶/۸؛ میان‌رده",
      "checkedAt": "2026-10-01",
      "logic": "قیمت مشاهده‌شدهٔ نمونهٔ پایه ۶۶٫۱۹۹ میلیون تومان بود؛ پیشنهاد مکعب به ۶۷ میلیون گرد شده. نمونهٔ دوم، یک میان‌ردهٔ گران‌تر برای مقایسه است.",
      "sources": [
        {
          "label": "تکنولایف، Redmi Pad 2 Pro 256/8",
          "url": "https://www.technolife.com/product-239548/تبلت-12.1-اینچ-شیائومی-مدل-redmi-pad-2-pro-ظرفیت-256-گیگابایت-رم-8-گیگابایت",
          "amount": 66199000,
          "unit": "toman",
          "date": null,
          "indexed": false
        },
        {
          "label": "تکنولایف، Galaxy Tab S10 FE WiFi 128/8",
          "url": "https://www.technolife.com/product-110363/تبلت-سامسونگ-مدل-galaxy-tab-s10-fe-wifi-ظرفیت-128-گیگابایت-رم-8-گیگابایت",
          "amount": 102756500,
          "unit": "toman",
          "date": null,
          "indexed": false
        }
      ]
    }
  },
  "phone": {
    "budgetToman": 122000000,
    "budgetNote": "سامسونگ Galaxy A56، حافظهٔ ۲۵۶ و رم ۸؛ نمونهٔ میان‌رده.",
    "scenario": {
      "title": "سامسونگ Galaxy A56 5G، ۲۵۶/۸، ویتنام",
      "checkedAt": "2026-10-01",
      "logic": "قیمت مشاهده‌شده ۱۲۱٫۲۸ میلیون تومان؛ پیشنهاد پایه به ۱۲۲ میلیون گرد شده.",
      "sources": [
        {
          "label": "تکنولایف، A56",
          "url": "https://www.technolife.com/product-99485/گوشی-موبايل-سامسونگ-galaxy-a56-5g-ظرفیت-256-گیگابایت-رم-8-گیگابایت---ویتنام",
          "amount": 121280000,
          "unit": "toman",
          "date": null,
          "indexed": false
        }
      ]
    }
  },
  "custom": {
    "budgetToman": 50000000,
    "budgetNote": "نقطهٔ شروع دلخواه شما؛ این هدف قیمت بازار ندارد.",
    "scenario": {
      "title": "ذخیرهٔ شخصی دلخواه؛ مبلغ نمونهٔ قابل ویرایش",
      "checkedAt": "2026-10-01",
      "logic": "این عدد انتخاب نمونهٔ مکعب است؛ بودجهٔ شخصی شما را خودتان تعیین می‌کنین.",
      "sources": []
    }
  },
  "migration": {
    "budgetToman": 2800000000,
    "budgetNote": "نمونهٔ ذخیره برای تمکن یک نفر در کانادا، با جدول ۲۰۲۵؛ هزینهٔ کامل مهاجرت نیست.",
    "scenario": {
      "title": "تمکن مالی یک نفر برای Express Entry کانادا؛ نمونهٔ مسیر مهاجرت",
      "checkedAt": "2026-10-01",
      "logic": "جدول ۷ ژوئیهٔ ۲۰۲۵: ۱۵٬۲۶۳ دلار کانادا برای یک نفر. با هر دلار آمریکا برابر ۱٫۴۱۸۸ دلار کانادا در ۲۹ سپتامبر ۲۰۲۶ و نرخ پایهٔ ۲۵۹٬۷۰۰ تومان برای دلار آمریکا، حدود ۲٫۸ میلیارد تومان می‌شه. این تمکن مالی است، نه هزینهٔ پرداختی یا تأیید شرایط مهاجرت؛ تعرفه و شرایط تازه را در منبع رسمی بررسی کنین.",
      "sources": [
        {
          "label": "IRCC، جدول تمکن مالی",
          "url": "https://www.canada.ca/en/immigration-refugees-citizenship/services/immigrate-canada/express-entry/documents/proof-funds.html",
          "amount": 15263,
          "unit": "CAD",
          "date": "2025-07-07",
          "indexed": false
        },
        {
          "label": "بانک مرکزی کانادا، نرخ روزانه",
          "url": "https://www.bankofcanada.ca/rates/exchange/daily-exchange-rates/",
          "amount": 1.4188,
          "unit": "CAD_per_USD",
          "date": "2026-09-29",
          "indexed": false
        }
      ]
    }
  },
  "university": {
    "budgetToman": 45000000,
    "budgetNote": "دو نیمسال ارشد علوم انسانی جهاد دانشگاهی اصفهان، تعرفهٔ ورودی ۱۴۰۴؛ زندگی و خوابگاه جدا.",
    "scenario": {
      "title": "دو نیمسال ارشد علوم انسانی، هر نیمسال۱۲واحد، مؤسسه جهاد دانشگاهی اصفهان؛ ورودی۱۴۰۴",
      "checkedAt": "2026-10-01",
      "logic": "هر نیمسال ۱۲ واحد عادی: دو برابرِ (۷۱٬۹۹۹٬۴۶۴ ریال شهریهٔ ثابت + ۱۲ × ۱۲٬۵۷۴٬۲۹۶ ریال). جمع حدود ۴۴٫۶ میلیون تومان و پایهٔ برنامه ۴۵ میلیون است. این تعرفهٔ ورودی ۱۴۰۴ است؛ پایان‌نامه و افزایش سال‌های بعد حساب نشده.",
      "sources": [
        {
          "label": "جدول رسمی شهریهٔ ارشد ورودی۱۴۰۴",
          "url": "https://jdeihe.ac.ir/wp-content/uploads/2025/12/جدول-شهریه-مقطع-کارشناسی-ارشد-ورودی1404-2-اصلاح-شده.pdf",
          "amount": null,
          "unit": "IRR",
          "date": "تعرفهٔ ورودی ۱۴۰۴",
          "indexed": false
        }
      ]
    }
  },
  "appliances": {
    "budgetToman": 268000000,
    "budgetNote": "سبد دو قلم: یخچال دوقلو ایکس‌ویژن و لباسشویی ۹ کیلویی دوو؛ جهیزیهٔ کامل نیست.",
    "scenario": {
      "title": "یخچال‌فریزر دوقلو ایکس‌ویژن KTR630/KTF630 و لباسشویی۹کیلویی دوو LM981S",
      "checkedAt": "2026-10-01",
      "logic": "۱۶۸٫۲ میلیون برای یخچال و ۹۹٫۵ میلیون برای لباسشویی؛ جمع ۲۶۷٫۷ میلیون، گرد شده به ۲۶۸ میلیون. قیمت‌ها از فهرست محصول ثبت شده‌اند؛ موجودی قطعی تأیید نشده.",
      "sources": [
        {
          "label": "تکنولایف، یخچال دوقلو ایکس‌ویژن",
          "url": "https://www.technolife.com/product-116180/یخچال-فریزر-دوقلو-ایکس-ویژن-مدل-ktr630-wd-ktf630-wd-",
          "amount": 168200000,
          "unit": "toman",
          "date": null,
          "indexed": true
        },
        {
          "label": "تکنولایف، دوو LM981S",
          "url": "https://www.technolife.com/product-80782/ماشین-لباسشویی-دوو-9-کیلویی-مدل-lm-981s",
          "amount": 99500000,
          "unit": "toman",
          "date": null,
          "indexed": true
        }
      ]
    }
  },
  "jewelry": {
    "budgetToman": 311000000,
    "budgetNote": "ارزش طلای یک سرویس سبک حدود ۱۲ گرمی ۱۸ عیار؛ اجرت و سنگ جدا.",
    "scenario": {
      "title": "ارزش طلای سرویس سبک حدود۱۲گرمی۱۸عیار، بدون اجرت و سنگ",
      "checkedAt": "2026-10-01",
      "logic": "نمونهٔ مشابه، ست دیپلمات ۱۲٫۷ گرمی است؛ برنامه برای حدود ۱۲ گرم طلا محاسبه می‌شه. صفحهٔ فهرست شاهد نوع محصوله و قیمت جاری کامل سرویس تأیید نشده.",
      "sources": [
        {
          "label": "رادصفری، ست دیپلمات۱۲٫۷۰گرمی۱۸عیار",
          "url": "https://radsafarigallery.com/p-category/semi-sets/?per_page=24&shop_view=list",
          "amount": null,
          "unit": "toman",
          "date": null,
          "indexed": true
        }
      ]
    }
  },
  "travel": {
    "budgetToman": 71000000,
    "budgetNote": "استانبول چهار شب؛ یک نفر در اتاق دوتخته با صبحانه و پرواز، مخارج شخصی جدا.",
    "scenario": {
      "title": "استانبول۴شب، یک نفر اتاق دوتخته Peak Star، صبحانه و پرواز؛ ۲۲تا۲۶مهر۱۴۰۵",
      "checkedAt": "2026-10-01",
      "logic": "پیشنهاد آژانس برای سفر ۲۲ تا ۲۶ مهر ۱۴۰۵، هتل Peak Star، هر نفر اتاق دوتخته، ۷۰٫۰۹ میلیون تومان؛ گرد شده به ۷۱ میلیون. اعتبار رزرو و هزینه‌های شخصی باید جدا بررسی بشن.",
      "sources": [
        {
          "label": "آژانس قصر شایان رویایی، لست‌سکند",
          "url": "https://lastsecond.ir/tours/277422-تور-استانبول-4-شب-پاییز-1405?bundle=10605951&itinerary=1405-07-22",
          "amount": 70090000,
          "unit": "toman_per_person_twin",
          "date": "1405-07-22 departure",
          "indexed": false
        }
      ]
    }
  },
  "gold": {
    "budgetToman": 130000000,
    "budgetNote": "ارزش فلز یک شمش ۵ گرمی طلای ۱۸ عیار؛ اجرت و هزینه‌های محصول جدا.",
    "scenario": {
      "title": "شمش۵گرمی طلای۱۸عیار۷۵۰، مطابق سناریوی فعلی مکعب",
      "checkedAt": "2026-10-01",
      "logic": "نمونهٔ فیزیکی هم ۵ گرم و ۱۸ عیار است. پیشنهاد پویا فقط ارزش همین مقدار طلا را محاسبه می‌کند؛ اجرت و شرایط تحویل فروشنده را به مکعب تعمیم نمی‌دهیم.",
      "sources": [
        {
          "label": "طلانکس، شمش۵گرمی۱۸عیار",
          "url": "https://talanex.com/shop/gold-bar-5g-18k",
          "amount": 121046301,
          "unit": "toman",
          "date": null,
          "indexed": false
        }
      ]
    }
  },
  "silver": {
    "budgetToman": 53000000,
    "budgetNote": "ارزش فلز یک شمش ۱۰۰ گرمی نقره؛ اجرت و تحویل جدا.",
    "scenario": {
      "title": "شمش۱۰۰گرمی نقره۹۹۹",
      "checkedAt": "2026-10-01",
      "logic": "نمونهٔ فیزیکی ۱۰۰ گرم نقرهٔ ۹۹۹ است. پیشنهاد پویا ارزش ۱۰۰ گرم فلز است و اجرت محصول را شامل نمی‌شود.",
      "sources": [
        {
          "label": "طلانکس، شمش۱۰۰گرمی نقره",
          "url": "https://talanex.com/shop/silver-bar-100g",
          "amount": 53340840,
          "unit": "toman",
          "date": null,
          "indexed": false
        }
      ]
    }
  },
  "copper": {
    "budgetToman": 5000000,
    "budgetNote": "ارزش یک کیلوگرم مس با نرخ ثبت‌شدهٔ مکعب؛ قیمت محصول ممکنه فرق داشته باشه.",
    "scenario": {
      "title": "شمش۱کیلوگرمی مس۹۹٫۹۹٪، مسیحا استیل",
      "checkedAt": "2026-10-01",
      "logic": "نمونهٔ فیزیکی شمش یک‌کیلویی مس ۹۹٫۹۹٪ با قیمت ۴٫۸۵ میلیون تومان است؛ پیشنهاد پویا از نرخ مسِ ثبت‌شدهٔ مکعب حساب می‌شود.",
      "sources": [
        {
          "label": "مسیحا استیل، شمش۱کیلویی۹۹٫۹۹٪",
          "url": "https://masihasteel.com/products/copper/single/شمش-مس-مسیحا-1-کیلویی-خلوص-9999--گواهی-آزمایشگاه",
          "amount": 4850000,
          "unit": "toman",
          "date": "1405-07-09 08:45",
          "indexed": false
        }
      ]
    }
  }
};
